/**
 * @desc 查看报警消息(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertMessageResponse>> {
  return defHttp.post({
    url: '/wap/alert/message/selectById',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertMessageResponse>> {
  return defHttp.post({
    url: '/mock/wap/alert/message/selectById',

    params,
  });
}
